import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TlkModalWindowRef, TLK_MODAL_WINDOW_DATA, TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { CloseEmptyIconComponent } from '@itero/ui-toolkit-angular/icons';
import { TranslateModule } from '@ngx-translate/core';

import {
	AdditionalInfoIds,
	AdditionalInfoFieldKey,
	AdditionalInfoResult
} from '@modules/rx-intuitive-crown-additional-info/models/additional-info';
import { CrownSelectionContext } from '@modules/rx-intuitive-crown/models/crown-models';
import { RxBannerComponent } from '@shared/components/rx-banner/rx-banner.component';
import { RxIntuitiveCrownAdditionalFieldsComponent } from '../rx-intuitive-crown-additional-fields/rx-intuitive-crown-additional-fields.component';

export interface RxIntuitiveAdditionalInfoModalData {
	isReadOnly: boolean;
	crownContext: CrownSelectionContext;
	initialValues: AdditionalInfoIds | null;
	shouldValidateForSend: boolean;
}

@Component({
	selector: 'rx-intuitive-additional-info-modal',
	templateUrl: './rx-intuitive-additional-info-modal.component.html',
	styleUrls: ['./rx-intuitive-additional-info-modal.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TranslateModule,
		TlkModalWindowModule,
		TlkButtonComponent,
		CloseEmptyIconComponent,
		RxBannerComponent,
		RxIntuitiveCrownAdditionalFieldsComponent
	]
})
export class RxIntuitiveAdditionalInfoModalComponent {
	private latestAdditionalInfo: AdditionalInfoIds | null = null;
	private latestClearedFields: AdditionalInfoFieldKey[] = [];

	constructor(
		private readonly dialogRef: TlkModalWindowRef<AdditionalInfoResult | null, RxIntuitiveAdditionalInfoModalComponent>,
		@Inject(TLK_MODAL_WINDOW_DATA) public readonly data: RxIntuitiveAdditionalInfoModalData
	) {}

	get materialOption() {
		return this.data.crownContext.materialOption;
	}

	get isShadeDisabled(): boolean {
		return !this.materialOption?.ShadeVisible;
	}

	onAdditionalInfoChange(info: AdditionalInfoIds): void {
		this.latestAdditionalInfo = info;
	}

	onClearedFieldsChange(fields: AdditionalInfoFieldKey[]): void {
		this.latestClearedFields = fields;
	}

	onSave(): void {
		if (this.data.isReadOnly || !this.latestAdditionalInfo) {
			this.dialogRef.close(null);

			return;
		}

		this.dialogRef.close({
			values: this.latestAdditionalInfo,
			clearedFields: this.latestClearedFields
		});
	}

	onCancel(): void {
		this.dialogRef.close(null);
	}
}
